import React, { FC, useState } from 'react'
import './styles.scss'
import Calendars from '../Calendars'
import { useSelector } from 'react-redux'
import { IProps } from './types'
import { Plann3rStore } from '../../../store/types'

const CalendarsPopup: FC<IProps> = ({ toggleClose, next, title, text, button_text }) => {
  // REDUX STORE
  const strings = useSelector((state: Plann3rStore) => state.languages.strings)

  // State
  const [ showCalendars, setShowCalendars ] = useState(false)

  /**
   * Handles the next event
   */
  const nextHandler = () => {
    // eslint-disable-next-line no-debugger
    debugger
    toggleClose()
    next()
  }

  /**
   * Returns the content based on the show calendars state
   */
  const getContent = () => {
    if (showCalendars) {
      return (
        <div className="content">
          <Calendars
            nextThing={ () => nextHandler() }
            nextThingNewAccount={ () => nextHandler() }
            nextThingText="Done"
          />
        </div>
      )
    }

    return (
      <div className="content">
        <span className="title">{ title }</span>
        <p className="body">{ text }</p>

        <div className="share">
          <button
            className="button is-primary morePadding wideOnMobile"
            onClick={ () => setShowCalendars(true) }
          >
            { button_text }
          </button>
          <p>{ strings.your_invitees }</p>
        </div>
      </div>
    )
  }

  return (
    <div className="sharemycalendar">
      <div className="closebutton">
        <span className="icon is-medium" onClick={ () => toggleClose() } role="presentation">
          <i className="fa fa-times" aria-hidden="true" />
        </span>
      </div>

      { getContent() }
    </div>
  )
}

export default CalendarsPopup
